<template>
  <div ref="primaryMenuWrapper" class="secondary-header--uniform-mobile secondary-soco-review">
    <div class="container">
      <div v-click-outside="hideMenu" class="box-secondary">
        <div id="primaryMenuMobileWrapper" class="hidden-lg hidden-md">
          <div class="primary-menu-mobile">
            <div class="primary-menu-mobile__item" :class="{ active: primaryMenuMobileActive === 'department' }">
              <a href="" class="primary-menu-mobile__toggle" @click.prevent="selectPrimaryMenuMobile(true)">
                <SvgImg name="icon_categories" width="33" height="33" alt="back-icon" class="icon-menu-mobile" />
                <p>
                  <span class="title">Explore by</span> <br />
                  <span class="subtitle">CATEGORIES</span>
                </p>
              </a>
            </div>
            <div class="divider"></div>
            <div class="primary-menu-mobile__item" :class="{ active: primaryMenuMobileActive === 'brand' }">
              <a href="" class="primary-menu-mobile__toggle" @click.prevent="selectBrowseByBrand('brand')">
                <SvgImg name="icon_brands" width="33" height="33" alt="back-icon" class="icon-menu-mobile" />
                <p>
                  <span class="title">Explore by</span> <br />
                  <span class="subtitle">Brands</span>
                </p>
              </a>
            </div>
          </div>
          <div class="primary-menu-mobile__content">
            <div v-show="primaryMenuMobileActive === 'department'">
              <ul class="list-departments">
                <template v-for="(grandParent, key) in categoriesOfDepartment">
                  <ItemGrandParent
                    :key="`itemGrandParent${key}`"
                    :grand-parent="grandParent"
                    :key-grand-parent="key"
                    @selected="setSelected(key)"
                  />
                </template>
              </ul>
              <template v-if="loading">
                <ul id="listParentMobile" class="list-category-department element-placeholder selected">
                  <li v-for="(n, i) in 3" :key="i">
                    <a href="" class="placeholder" style="width: 80px" />
                  </li>
                </ul>
              </template>
              <template v-else>
                <ul
                  v-if="activeIndexGrandParent >= 0"
                  id="listParentMobile"
                  class="list-category-department"
                  :class="{ selected: $SO.size(parentActive) }"
                >
                  <li ref="listAllParent">
                    <router-link
                      :to="`/category/${categoriesOfDepartment[activeIndexGrandParent].my_soco_sql_id}/${grandParentSlug}`"
                      @click.native="selectParent"
                      >All {{ categoriesOfDepartment[activeIndexGrandParent].name | ucwords }}</router-link
                    >
                  </li>
                  <ItemParent
                    v-for="(parent, key) in parentActive"
                    :key="`itemParent${key}`"
                    :parent="parent"
                    :grand-parent="categoriesOfDepartment[activeIndexGrandParent].children"
                    :key-parent="key"
                  />
                </ul>
                <ul
                  v-if="activeIndexParent >= 0 && activeIndexGrandParent >= 0"
                  class="list-subcategory-department"
                  :class="{ selected: $SO.size(childActive) }"
                >
                  <ItemChild
                    v-for="(child, key) in childActive"
                    :key="`itemChild${key}`"
                    :parent="parentActive[activeIndexParent]"
                    :grand-parent="categoriesOfDepartment[activeIndexGrandParent]"
                    :child="child"
                    :key-child="key"
                  />
                </ul>
              </template>
            </div>

            <!-- <div class="mega-menu--brand-mobile" v-show="isBrowseByBrand">
              <Brands key="navbarBrandMobile"></Brands>
            </div> -->
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import ItemGrandParent from './item-grand-parent';
import ItemParent from './item-parent';
import ItemChild from './item-child';
import ClickOutside from 'vue-click-outside';
export default {
  name: 'header-primary-menu-mobile',
  components: {
    ItemGrandParent,
    ItemParent,
    ItemChild,
  },
  directives: {
    ClickOutside,
  },
  data() {
    return {
      loading: false,
    };
  },
  computed: {
    screen() {
      return this.$store.state.screen;
    },
    activeHeaderMenu() {
      return this.$store.state.activeHeaderMenu;
    },
    activeIndexChild() {
      return this.$store.state.header.mobile.activeIndexChild;
    },
    activeIndexGrandParent() {
      return this.$store.state.header.mobile.activeIndexGrandParent;
    },
    activeIndexParent() {
      return this.$store.state.header.mobile.activeIndexParent;
    },
    brands() {
      return this.$store.state.brands;
    },
    categoriesOfDepartment() {
      return this.$store.state.header.categoriesOfDepartment;
    },
    childActive() {
      if (this.activeIndexGrandParent >= 0 && this.activeIndexParent >= 0) {
        return this.parentActive[this.activeIndexParent].children;
      } else {
        return {};
      }
    },
    grandParentSlug() {
      if (this.activeIndexGrandParent >= 0) {
        return this.$options.filters.slug(this.categoriesOfDepartment[this.activeIndexGrandParent].name);
      } else {
        return 'default';
      }
    },
    parentActive() {
      if (this.activeIndexGrandParent >= 0) {
        return this.categoriesOfDepartment[this.activeIndexGrandParent].children;
      } else {
        return {};
      }
    },
    popularMakeup() {
      return this.$store.state.popularMakeup;
    },
    primaryMenuMobileActive() {
      return this.$store.state.header.primaryMenuMobileActive;
    },
    isLogin() {
      return this.$SO.size(this.$store.state.auth.userProfile);
    },
    user() {
      return this.$store.state.auth.userProfile;
    },
    // isBrowseByBrand() {
    //   return this.$store.state.filterProduct.browseBy.brand;
    // }
  },
  watch: {
    primaryMenuMobileActive() {
      if (!this.$store.state.screen.isDesktop) {
        if (this.primaryMenuMobileActive) {
          const overlayElement = document.createElement('div');
          const bodyElement = document.querySelector('body');
          overlayElement.setAttribute('id', 'overlayStyle');

          if (Boolean(document.getElementById('overlayStyle')) === false) {
            bodyElement.appendChild(overlayElement);
            this.$SO('body').addClass('no-scroll');
          }
        } else {
          const overlayElement = document.getElementById('overlayStyle');
          overlayElement.remove();
          this.$SO('body').removeClass('no-scroll');
          this.$store.commit('updateActiveIndexGrandParent', -1);
          this.$store.commit('updateActiveIndexParent', -1);
          this.$store.commit('updateActiveIndexChild', -1);
        }
      }
    },
  },
  mounted() {
    if (this.screen.isDesktop) {
      window.addEventListener('scroll', this.handleScroll, {
        capture: true,
        passive: true,
        behavior: 'smooth',
      });
    }
    document.addEventListener('click', this.documentClick);
  },
  destroyed() {
    document.removeEventListener('click', this.documentClick);
    const overlayElement = document.getElementById('overlayStyle');
    if (overlayElement) {
      overlayElement.remove();
    }
    this.$SO('body').removeClass('no-scroll');
    this.$store.commit('updateActiveIndexGrandParent', -1);
    this.$store.commit('updateActiveIndexParent', -1);
    this.$store.commit('updateActiveIndexChild', -1);
  },
  methods: {
    documentClick(e) {
      const target = e.target;

      if (this.primaryMenuMobileActive) {
        if (this.$SO(target).closest('#primaryMenuMobileWrapper').length < 1) {
          this.$store.commit('updatePrimaryMenuMobile', '');
        }
      }
    },
    setActiveHeaderMenu(name) {
      if (this.activeHeaderMenu && this.activeHeaderMenu == name) {
        this.$store.commit('setActiveHeaderMenu', '');
      } else {
        this.$store.commit('setActiveHeaderMenu', name);
      }
    },
    handleScroll(event) {
      const el = this.$refs.primaryMenuWrapper;

      if (el) {
        const scrollY = window.pageYOffset || document.documentElement.scrollTop;
        const header = el;

        if (this.screen.isDesktop) {
          header.classList.add('start-scroll');
          if (header && scrollY <= this.lastScroll) {
            header.classList.add('sticky');
          } else {
            header.classList.remove('sticky');
          }

          if (scrollY < 100) {
            header.classList.remove('sticky');
          }

          if (scrollY === 0) {
            header.classList.add('sticky');
          }
        }

        this.lastScroll = scrollY;
      }
    },
    selectParent(e) {
      this.$store.commit('updateActiveIndexParent', -1);
      this.$store.commit('updateActiveIndexChild', -1);
      this.$store.commit('updatePrimaryMenuMobile', '');
    },
    selectBrowseByBrand(type) {
      this.$store.commit('setBrowseBy', { type: 'brand', value: true });
    },
    selectPrimaryMenuMobile(menuFlag) {
      // const newValue = menuFlag === this.primaryMenuMobileActive ? '' : menuFlag;
      this.$store.commit('SET_SHOW_CATEGORY', menuFlag);
    },
    setSelected(data) {
      this.$store.commit('updateActiveIndexGrandParent', data);
      // if (!this.categoriesOfDepartment[data.indexArray].children) {
      // this.loading = true;
      // this.$store
      //   .dispatch('getChildrenOfDepartments', {
      //     categoryId: data._id,
      //     categoriesOfDepartmentKey: data.indexArray,
      //   })
      //   .then((res) => {
      //     this.loading = false;
      //   })
      //   .catch((err) => {
      //     this.loading = false;
      //   });
      // }
    },
    hideMenu() {
      this.setActiveHeaderMenu(null);
    },
    productMatch() {
      if (this.isLogin) {
        if (Boolean(this.user.beauty && this.user.beauty.length)) {
          this.$router.push('/our-curated-selection');
        } else {
          this.$store.commit('toggleModalGlobalState', {
            modalName: 'confirmBP',
          });
        }
      } else {
        this.$store.commit('modalAuth', 1);
      }
    },
  },
};
</script>
